import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataToolsLiteMessage } from '../DataToolsLiteMessage';

@Injectable({
  providedIn: 'root'
})
export class DatatoolsLiteService {
  triggerMessage$: Subject<DataToolsLiteMessage>;

  constructor() {
    this.triggerMessage$ = new Subject<DataToolsLiteMessage>();
  }
}
